// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import CompanySearchController from "./company_search_controller"
application.register("company-search", CompanySearchController)

import ConfirmationDialogController from "./confirmation_dialog_controller"
application.register("confirmation-dialog", ConfirmationDialogController)

import DocumentTypeLoaderController from "./document_type_loader_controller"
application.register("document-type-loader", DocumentTypeLoaderController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ErrorCaptureController from "./error_capture_controller"
application.register("error-capture", ErrorCaptureController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalOpenerController from "./modal_opener_controller"
application.register("modal-opener", ModalOpenerController)

import PasswordChangeController from "./password_change_controller"
application.register("password-change", PasswordChangeController)

import PatientSearchController from "./patient_search_controller"
application.register("patient-search", PatientSearchController)

import PatientSearchFrameController from "./patient_search_frame_controller"
application.register("patient-search-frame", PatientSearchFrameController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import SettingsDropdownController from "./settings_dropdown_controller"
application.register("settings-dropdown", SettingsDropdownController)

import SyncStatusController from "./sync_status_controller"
application.register("sync-status", SyncStatusController)

import UploadDestinationsController from "./upload_destinations_controller"
application.register("upload-destinations", UploadDestinationsController)

import UploadFormValidationController from "./upload_form_validation_controller"
application.register("upload-form-validation", UploadFormValidationController)
